import { TripSummary } from "@types";

export const filteredTrips = (searchValue: string, row: TripSummary) => {
    if (searchValue.length === 0) return true;

    const searchNormalized = removeAccents(searchValue.toLowerCase());

    return (
        removeAccents(row.driverName?.toLowerCase() || '').includes(searchNormalized) ||
        removeAccents(row.vehicle?.toLowerCase() || '').includes(searchNormalized) ||
        removeAccents(row.routeName?.toLowerCase() || '').includes(searchNormalized) ||
        removeAccents(row.origin?.toLowerCase() || '').includes(searchNormalized) ||
        removeAccents(row.destination?.toLowerCase() || '').includes(searchNormalized) ||
        removeAccents(String(row.plannedDistance || '').toLowerCase()).includes(searchNormalized) ||
        removeAccents(String(row.distance || '').toLowerCase()).includes(searchNormalized) ||
        removeAccents(String(row.co2Emission || '').toLowerCase()).includes(searchNormalized) ||
        removeAccents(String(row.plannedCo2Emission || '').toLowerCase()).includes(searchNormalized) ||
        removeAccents(String(row.fuelConsumption || '').toLowerCase()).includes(searchNormalized) ||
        removeAccents(String(row.plannedFuelConsumption || '').toLowerCase()).includes(searchNormalized) ||
        removeAccents(String(row.idleTime || '').toLowerCase()).includes(searchNormalized) ||
        removeAccents(String(row.plannedIdleTime || '').toLowerCase()).includes(searchNormalized) ||
        removeAccents(String(row.totalTime || '').toLowerCase()).includes(searchNormalized) ||
        removeAccents(String(row.plannedTime || '').toLowerCase()).includes(searchNormalized) ||
        removeAccents(row.tripDate?.toLowerCase() || '').includes(searchNormalized)
    );
};

const removeAccents = (str: string): string => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};